// React imports.
import React from "react";

import { Assessment2aStepsEnum } from "../state";
import { Assessment2aModel } from "../state";
import { Assessment2aStatusEnum } from "../state";

const Assessment2aTopParagraph = ({model }) => (
    <div>
        {(model.totalVendorStatus === Assessment2aStatusEnum.MeetsMinRequirement5Plus)
          &&  <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong> have  not </strong>  been flagged because you both requested and received
                data from at least 5 electricity vendors. This means that you
                likely <strong>do not</strong>  have a data reliability issue with regards to
                data collection for electric baseload expenditure data.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.MeetsMinRequirementUnder5)
        &&
            <p>
                <strong>
                    Status: No data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong>have not</strong>  been flagged because your state has fewer than 5 electric
                vendors and you requested and received data from all of them.  This
                means that you likely <strong>do not</strong>  have a data reliability issue
                with regards to data collection for electric baseload expenditure data.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMin5Plus)
        &&
            <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong> have </strong> been flagged because you did not  <strong> request </strong> data
                from at least 5 electric vendors in your state/territory. This means that
                you <strong> may </strong> have a data reliability issue because collecting
                data from fewer vendors increases the probability that the
                sample you have collected is not adequately representative
                of the entire state/territory.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMin5Plus)
        &&
            <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong> have </strong> been flagged because you requested but did not
                <strong> receive </strong> data from at least 5 electric vendors in
                your state/territory. This means that you <strong> may </strong> have a
                data reliability issue because collecting data from
                fewer vendors increases the probability that the
                sample you have collected is not adequately representative
                of the entire state/territory.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.RequestedUnderMinUnder5)
        &&
            <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong> have been </strong>  flagged because your state/territory has
                fewer than 5 electric vendors, but you did
                not <strong> request </strong>  data from all of them. This means that you 
                may have a data reliability issue for electric expenditure 
                data because collecting data from fewer vendors increases 
                the probability that the sample you have collected is not 
                adequately representative of the entire state/territory.
            </p>
        }
        {(model.totalVendorStatus === Assessment2aStatusEnum.ReceivedUnderMinUnder5)
        &&
            <p>
                <strong>
                    Status: Potential data reliability issue present!
                </strong>&nbsp;
                Your data collection efforts for electric baseload expenditures
                <strong> have </strong> been flagged because your state/territory has fewer
                than 5 electric vendors and you requested, but did
                not <strong> receive</strong>,  data from all of them. This means that you may
                have a data reliability issue because collecting data from
                fewer vendors increases the probability that the sample you
                have collected is not adequately representative of the entire state/territory.
            </p>
        }
    </div>
);

export default Assessment2aTopParagraph;
